'use client';

import { c as _c } from "react/compiler-runtime";
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import type { PropsWithChildren } from 'react';

/**
 * The nuqs adapter, isolated so it can be mounted independently of the rest
 * of the provider stack.
 *
 * `NuqsAdapter` calls `useSearchParams()`, which can't complete during a
 * prerender, and React renders top-down — so any tree it wraps is excluded
 * from the static shell. Mount it around the smallest subtree that uses
 * `useQueryState`, behind a `<Suspense>`, not at a layout root.
 * @see https://nextjs.org/docs/messages/missing-suspense-with-csr-bailout
 *
 * Must stay a client component: `processUrlSearchParams` is a function and
 * can't cross the server/client boundary as a prop.
 */
export const SearchParamsAdapter = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <NuqsAdapter processUrlSearchParams={_temp}>{children}</NuqsAdapter>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(search) {
  search.sort();
  return search;
}